<template>
  <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 12 : 4]">
    <v-hover v-slot:default="{ hover }">
      <v-card
        class="mx-auto"
        color="grey lighten-4"
        max-width="400"
      >
        <v-img
          :aspect-ratio="16/9"
          :src="image"
        >
          <v-expand-transition>
            <div
              v-if="hover"
              class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-1 white--text"
              :class="color"
              style="height: 100%;"
            >
              {{desc}}
            </div>
          </v-expand-transition>
        </v-img>
        <v-card-text
          class="pt-6"
          style="position: relative;"
        >
          <v-btn
            absolute
            :color="color"
            class="white--text"
            fab
            large
            right
            top
            @click='link'
          >
            <v-icon>mdi-play-circle-outline</v-icon>
          </v-btn>
          <p class="subtitle-1 font-weight-light black--text mb-2">{{title}}</p>
        </v-card-text>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
    export default {
      name: 'HoverCard',
      props: {
        title: String,
        color: String,
        route: String,
        image: String,
        desc: String
      },
      methods:{
        link: function(){
          window.scrollTo(0,0);
          this.$router.push(this.route)
        }
      }
    }
</script>

<style>
    .v-card--reveal {
      align-items: center;
      bottom: 0;
      justify-content: center;
      opacity: .7;
      position: absolute;
      width: 100%;
    }
</style>